/* eslint-disable no-unused-vars */
import React, { memo, useMemo } from 'react';
import _ from 'lodash';

import CollapseableFilter from './task-status';
import PriorityFilter from './priority';
import DueDateFilter from './due-date';
import style from './style.module.scss';
import Divider from '@components/divider';

const TaskFilterGroup = ({
  filterType = null,
  taskTypeTag,
  filters,
  updateFilters,
  taskStatusTags,
  workOrderTypeTags,
  workOrderTypeTagsMap,
  assignableUsersTags,
  picklistsMap,
  workOrderPriorityTags,
  taskRecurringTemplateTags,
  isActive,
  equipmentListing = false,
  siteListing = true,
  pipelineListing = false,
  tasksListing = false,
  asset,
  inspectionRunTags,
  inspectionTypeTags,
  hseEventsCategoriesTags,
  checkTypeTags,
  checkRecurrancePriorityTags,
  checkTypeTagsMap,
  inspectionTypeTagsMap,
  equipmentCategoryTags = [],
  equipmentTypeTags = []
}) => {
  const showEquipmentCategoryTags = useMemo(() => {
    return filterType === 'newOrEditAssets' && !_.isEmpty(equipmentCategoryTags);
  }, [filterType, equipmentCategoryTags]);

  const showEquipmentTypeTags = useMemo(() => {
    return filterType === 'newOrEditAssets' && !_.isEmpty(equipmentTypeTags);
  }, [filterType, equipmentTypeTags]);

  const showTaskTypeTags = useMemo(() => {
    return (
      filterType !== 'inspection' &&
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType !== 'workRequest' &&
      filterType !== 'Work Request' &&
      filterType !== 'Inspection' &&
      filterType !== 'Work Order' &&
      filterType !== 'hseEvents' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(taskTypeTag)
    );
  }, [filterType, taskTypeTag]);

  const showCheckTypeTags = useMemo(() => {
    return (
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType !== 'inspection' &&
      filterType !== 'Inspection' &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(checkTypeTags)
    );
  }, [filterType, checkTypeTags]);

  const showWorkOrderTypeTagsIfTasksListingIsTrue = useMemo(() => {
    return (
      !asset &&
      filterType !== 'workRequest' &&
      filterType !== 'Work Request' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType?.toLowerCase() !== 'inspection' &&
      filterType !== 'hseEvents' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(workOrderTypeTags)
    );
  }, [asset, filterType, workOrderTypeTags]);

  const showWorkOrderTypeTagsIfTasksListingIsFalse = useMemo(() => {
    return (
      filterType?.toLowerCase() !== 'check' &&
      filterType?.toLowerCase() !== 'inspection' &&
      filterType !== 'Work Request' &&
      filterType !== 'hseEvents' &&
      !_.isEmpty(workOrderTypeTags)
    );
  }, [pipelineListing, filterType, workOrderTypeTags]);

  const showAssignedToTagsIfTasksListingIsTrue = useMemo(() => {
    return (
      filterType !== 'inspection' &&
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType !== 'Inspection' &&
      filterType !== 'Work Order' &&
      filterType !== 'hseEvents' &&
      filterType !== 'workRequest' &&
      filterType !== 'Work Request' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType !== 'newOrEditAssets' &&
      assignableUsersTags?.length > 0
    );
  }, [filterType, assignableUsersTags]);

  const showWorkOrderPriorityTypeTagsIfTaskListingIsTrue = useMemo(() => {
    return (
      filterType?.toLowerCase() !== 'inspection' &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      (_.size(workOrderPriorityTags) > 0 || _.size(checkRecurrancePriorityTags) > 0)
    );
  }, [filterType, workOrderPriorityTags, checkRecurrancePriorityTags]);

  const showWorkOrderPriorityTypeTagsIfTaskListingIsFalse = useMemo(() => {
    return (
      (_.size(workOrderPriorityTags) > 0 || _.size(checkRecurrancePriorityTags) > 0) &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets'
    );
  }, [workOrderPriorityTags, checkRecurrancePriorityTags]);

  const showRecurringTemplateTagsIfTasksListingIsTrue = useMemo(() => {
    return (
      filterType?.toLowerCase() !== 'inspection' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      taskRecurringTemplateTags?.length > 0
    );
  }, [filterType, taskRecurringTemplateTags]);

  const showRecurringTemplateTagsIfTasksListingIsFalse = useMemo(() => {
    return (
      !pipelineListing &&
      filterType !== 'check' &&
      filterType !== 'Check' &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      taskRecurringTemplateTags?.length > 0
    );
  }, [pipelineListing, filterType, taskRecurringTemplateTags]);

  const showInspectionRunTypeTags = useMemo(() => {
    return (
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType !== 'check' &&
      filterType !== 'Check' &&
      filterType !== 'hseEvents' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(inspectionRunTags)
    );
  }, [filterType, inspectionRunTags]);

  const showInspectionTypeTags = useMemo(() => {
    return (
      // tasksListing &&
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType !== 'hseEvents' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(inspectionTypeTags)
    );
  }, [tasksListing, filterType, inspectionTypeTags]);

  const showHSEEventCategoryTypeTags = useMemo(() => {
    return (
      filterType !== 'workOrder' &&
      filterType !== 'Work Order' &&
      filterType?.toLowerCase() !== 'inspection' &&
      filterType?.toLowerCase() !== 'check' &&
      filterType !== 'Work Request' &&
      filterType !== 'newOrEditAssets' &&
      !_.isEmpty(hseEventsCategoriesTags)
    );
  }, [filterType, hseEventsCategoriesTags]);

  const showDueDateAndScheduleDateFilter = useMemo(() => {
    return (
      filterType !== 'newOrEditAssets' &&
      filterType !== 'hseEvents' &&
      filterType !== 'workRequest' &&
      filterType !== 'Work Request'
    );
  }, [filterType]);

  const showCreatedDateFilter = useMemo(() => {
    return (
      tasksListing &&
      filterType?.toLowerCase() !== 'inspection' &&
      filterType !== 'hseEvents' &&
      filterType !== 'newOrEditAssets' &&
      filterType?.toLowerCase() !== 'check'
    );
  }, [tasksListing, filterType]);

  const filterDatesConfigs = [
    {
      key: 'dueDate',
      show: showDueDateAndScheduleDateFilter,
      header: 'Due date',
      options: [...datesFilterOptions, { value: 'next', label: 'In the next' }],
      showUnLimitedOptionOnPast: true,
      removeUnlimitedTagFromNext: true
    },
    {
      key: 'scheduledDate',
      show: showDueDateAndScheduleDateFilter,
      header: 'Scheduled date',
      options: [...datesFilterOptions, { value: 'next', label: 'In the next' }],

      showUnLimitedOptionOnPast: true,
      removeUnlimitedTagFromNext: true
    },
    {
      key: 'createdAt',
      show: showCreatedDateFilter,
      header: 'Created',
      options: datesFilterOptions
    },
    {
      key: 'syncedDate',
      show: true,
      header: 'Synced',
      options: datesFilterOptions
    }
  ];

  return (
    <>
      {!tasksListing && (
        <div className={style.filterHeader}>
          <p>Tasks</p>
        </div>
      )}
      <section>
        {/* Task Type Tags */}
        {showTaskTypeTags && (
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Task type'}
                tags={taskTypeTag || []}
                multi
                value={filters?.taskType?.value}
                onChange={(value) => updateFilters('taskType', 'value', value)}
              />
            </div>
            <Divider />
          </>
        )}

        {/* Tasks Status Tags */}
        <div>
          <>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Task status'}
                tags={taskStatusTags || ['To do', 'In progress', 'Pending sync', 'Synced']}
                multi
                value={filters?.taskStatus?.value}
                onChange={(value) => updateFilters('taskStatus', 'value', value)}
              />
            </div>
            <Divider />
          </>
        </div>

        {showEquipmentCategoryTags && (
          <div>
            {equipmentCategoryTags?.length > 0 && (
              <>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Equipment category'}
                    tags={equipmentCategoryTags || []}
                    tagsMap={picklistsMap}
                    multi
                    value={filters?.equipmentCategory?.value}
                    onChange={(value) => updateFilters('equipmentCategory', 'value', value)}
                  />
                </div>
                <Divider />
              </>
            )}
          </div>
        )}

        {showEquipmentTypeTags && (
          <div>
            {equipmentTypeTags?.length > 0 && (
              <>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Equipment type'}
                    tags={equipmentTypeTags || []}
                    tagsMap={picklistsMap}
                    multi
                    value={filters?.equipmentType?.value}
                    onChange={(value) => updateFilters('equipmentType', 'value', value)}
                  />
                </div>
                <Divider />
              </>
            )}
          </div>
        )}

        {/* Assigned To Tags */}

        {tasksListing
          ? showAssignedToTagsIfTasksListingIsTrue && (
              <>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Assigned to'}
                    tags={assignableUsersTags}
                    multi
                    value={filters?.assign?.value}
                    onChange={(value) => updateFilters('assign', 'value', value)}
                  />
                </div>
                <Divider />
              </>
            )
          : assignableUsersTags?.length > 0 &&
            filterType !== 'Work Request' &&
            filterType !== 'hseEvents' && (
              <>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Assigned to'}
                    tags={assignableUsersTags}
                    multi
                    value={filters?.assign?.value}
                    onChange={(value) => updateFilters('assign', 'value', value)}
                  />
                </div>
                <Divider />
              </>
            )}

        {/* Priority Type Tags */}

        {tasksListing
          ? showWorkOrderPriorityTypeTagsIfTaskListingIsTrue && (
              <div>
                <div className={style.filterRowContainer}>
                  <PriorityFilter
                    multi
                    isActive={isActive}
                    title={'Priority'}
                    label1={
                      filterType !== 'Work Order' &&
                      filterType !== 'workOrder' &&
                      filterType !== 'Work Request' &&
                      checkRecurrancePriorityTags?.length > 0
                        ? 'Checks'
                        : ''
                    }
                    tagsMap1={picklistsMap}
                    tags1={checkRecurrancePriorityTags}
                    value1={filters?.checkRecurrancePriority?.value}
                    onChange1={(value) => updateFilters('checkRecurrancePriority', 'value', value)}
                    label2={
                      filterType?.toLowerCase() !== 'check'
                        ? _.size(workOrderPriorityTags) > 0
                          ? filterType === 'workRequest' || filterType === 'Work Request'
                            ? 'Work Request'
                            : 'Work Orders'
                          : ''
                        : ''
                    }
                    tagsMap2={picklistsMap}
                    tags2={filterType === 'check' ? [] : workOrderPriorityTags}
                    value2={filters?.workOrderPriority.value}
                    onChange2={(value) => updateFilters('workOrderPriority', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )
          : showWorkOrderPriorityTypeTagsIfTaskListingIsFalse && (
              <div>
                <div className={style.filterRowContainer}>
                  <PriorityFilter
                    multi
                    isActive={isActive}
                    title={'Priority'}
                    label2={
                      filterType === 'check'
                        ? ''
                        : _.size(workOrderPriorityTags) > 0
                        ? 'Work Orders'
                        : ''
                    }
                    tagsMap2={picklistsMap}
                    tags2={filterType === 'check' ? [] : workOrderPriorityTags}
                    value2={filters?.workOrderPriority?.value}
                    onChange2={(value) => updateFilters('workOrderPriority', 'value', value)}
                    label1={checkRecurrancePriorityTags?.length > 0 ? 'Checks' : ''}
                    tagsMap1={picklistsMap}
                    tags1={checkRecurrancePriorityTags}
                    value1={filters?.checkRecurrancePriority?.value}
                    onChange1={(value) => updateFilters('checkRecurrancePriority', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )}

        {/* Recurring Template Tags */}
        {tasksListing
          ? showRecurringTemplateTagsIfTasksListingIsTrue && (
              <div>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Recurring template'}
                    tags={taskRecurringTemplateTags || []}
                    multi
                    value={filters?.recurringTemplate.value}
                    onChange={(value) => updateFilters('recurringTemplate', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )
          : showRecurringTemplateTagsIfTasksListingIsFalse && (
              <div>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Recurring template'}
                    tags={taskRecurringTemplateTags || []}
                    multi
                    value={filters?.recurringTemplate.value}
                    onChange={(value) => updateFilters('recurringTemplate', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )}

        {/* Work Order Type Tags */}
        {tasksListing
          ? showWorkOrderTypeTagsIfTasksListingIsTrue && (
              <div>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Work order type'}
                    tags={workOrderTypeTags || []}
                    tagsMap={workOrderTypeTagsMap}
                    multi
                    value={filters?.workOrderType?.value}
                    onChange={(value) => updateFilters('workOrderType', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )
          : showWorkOrderTypeTagsIfTasksListingIsFalse && (
              <div>
                <div className={style.filterRowContainer}>
                  <CollapseableFilter
                    title={'Work order type'}
                    tags={workOrderTypeTags || []}
                    tagsMap={workOrderTypeTagsMap}
                    multi
                    value={filters?.workOrderType?.value}
                    onChange={(value) => updateFilters('workOrderType', 'value', value)}
                  />
                </div>
                <Divider />
              </div>
            )}

        {/* show inspection run type tags */}

        {showInspectionRunTypeTags && (
          <div>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Inspection run'}
                tags={inspectionRunTags || []}
                multi
                value={filters?.inspectionRun?.value}
                onChange={(value) => updateFilters('inspectionRun', 'value', value)}
              />
            </div>
            <Divider />
          </div>
        )}

        {/* inspection Type Tags */}

        {showInspectionTypeTags && (
          <div>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Inspection form'}
                tags={inspectionTypeTags || []}
                multi
                value={filters?.inspectionType?.value}
                onChange={(value) => updateFilters('inspectionType', 'value', value)}
                tagsMap={inspectionTypeTagsMap}
              />
            </div>
            <Divider />
          </div>
        )}

        {/* check Type Tags */}

        {showCheckTypeTags && (
          <div>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={'Check type'}
                tags={checkTypeTags || []}
                multi
                value={filters?.checkType?.value}
                onChange={(value) => updateFilters('checkType', 'value', value)}
                tagsMap={checkTypeTagsMap}
              />
            </div>
            <Divider />
          </div>
        )}

        {/* HSE event Category type tags */}

        {showHSEEventCategoryTypeTags && (
          <div>
            <div className={style.filterRowContainer}>
              <CollapseableFilter
                title={filterType === 'hseEvents' ? 'Category' : 'HSE event category'}
                tags={hseEventsCategoriesTags || []}
                multi
                value={filters?.hseEventCategory?.value}
                onChange={(value) => updateFilters('hseEventCategory', 'value', value)}
              />
            </div>
            <Divider />
          </div>
        )}

        {filterDatesConfigs.map(
          ({ key, show, header, options, ...rest }) =>
            show && (
              <div key={key}>
                <div className={style.filterRowContainer}>
                  <DueDateFilter
                    tagName={'dueDate'}
                    header={header}
                    selectedTagName={key}
                    defaultValue={
                      filters?.[key]?.selected === 'past'
                        ? { value: 'past', label: 'In the past' }
                        : filters?.[key]?.selected === 'next'
                        ? { value: 'next', label: 'In the next' }
                        : {}
                    }
                    value={filters?.[key]?.value}
                    selected={filters?.[key]?.selected}
                    onChange={(value) => updateFilters(key, 'value', value)}
                    onSelect={(selected) => updateFilters(key, 'selected', selected)}
                    options={options}
                    {...rest}
                  />
                </div>
                <Divider />
              </div>
            )
        )}
      </section>
    </>
  );
};

export default memo(TaskFilterGroup);

let datesFilterOptions = [
  { value: 'on', label: 'On' },
  { value: 'range', label: 'Range' },
  { value: 'past', label: 'In the past' }
];
